import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { getWorkflows, getLatestWorkflow, setLatestWorkflow, getCarriers, getConfidenceThreshold, updateConfidenceThreshold, getFeatureFlags, updateFeatureFlag } from '../api/settings'

export function useWorkflows() {
  return useQuery({
    queryKey: ['workflows'],
    queryFn: getWorkflows,
    staleTime: 1000 * 60 * 5, // 5 minutes
  })
}

export function useLatestWorkflow() {
  return useQuery({
    queryKey: ['workflows', 'latest'],
    queryFn: getLatestWorkflow,
  })
}

export function useSetLatestWorkflow() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: setLatestWorkflow,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['workflows'] })
    },
  })
}

export function useCarriers() {
  return useQuery({
    queryKey: ['carriers'],
    queryFn: getCarriers,
    staleTime: 1000 * 60 * 10, // 10 minutes
  })
}

export function useConfidenceThreshold() {
  return useQuery({
    queryKey: ['settings', 'confidence-threshold'],
    queryFn: getConfidenceThreshold,
    staleTime: 1000 * 60 * 5, // 5 minutes
  })
}

export function useUpdateConfidenceThreshold() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: updateConfidenceThreshold,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['settings', 'confidence-threshold'] })
    },
  })
}

export function useFeatureFlags() {
  return useQuery({
    queryKey: ['settings', 'feature-flags'],
    queryFn: getFeatureFlags,
    staleTime: 1000 * 60 * 5, // 5 minutes
  })
}

export function useUpdateFeatureFlag() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: ({ key, enabled }: { key: string; enabled: boolean }) =>
      updateFeatureFlag(key, enabled),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['settings', 'feature-flags'] })
    },
  })
}
